"use strict";
/*
Copyright (C) 2009 - 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultAccountStatuses = void 0;
/**
 * Describes the default statuses of an <<Account>>.
 */
var DefaultAccountStatuses;
(function (DefaultAccountStatuses) {
    DefaultAccountStatuses["ACTIVE"] = "ACTIVE";
    DefaultAccountStatuses["INACTIVE"] = "INACTIVE";
})(DefaultAccountStatuses = exports.DefaultAccountStatuses || (exports.DefaultAccountStatuses = {}));
//# sourceMappingURL=account.js.map